import { DeviceInfo } from '../device-info';
import { Credentials, PasswordChangeInfo, UserInfo, SinupCredentials } from '../user-info';

export enum LoginResult {
    LoginSuccess = 'login_success',
    LoginTwoFactorRequired = 'login_two_factor_required',
    LoginFailed = 'login_failed',
}

export type LoginActionType = (credentials: Credentials) => Promise<LoginResult>;
export type SignupActionType = (signupCredentials: SinupCredentials) => Promise<LoginResult>;
export type ResetPasswordActionType = ({ email }: { email: string }) => Promise<void>;
export type ResendVerificationEmailActionType = ({ email }: { email: string }) => Promise<void>;
export type SetNewPasswordActionType = ({
    token,
    password,
    confirmation,
}: {
    token: string;
    password: string;
    confirmation: string;
}) => Promise<void>;
export type VerifyEmailActionType = ({ token }: { token: string }) => Promise<any>;
export type LoadDeviceActionType = ({ deviceUUID }: { deviceUUID: string }) => Promise<DeviceInfo>;
export type LoadDevicesActionType = ({ userId }: { userId: string }) => Promise<DeviceInfo[]>;
export type LoadGroupsActionType = () => Promise<any[]>;
export type UpdateDeviceActionType = ({ device }: { device: Partial<DeviceInfo> }) => Promise<DeviceInfo>;
export type UpdateUserActionType = ({ user }: { user: Partial<UserInfo> }) => Promise<boolean>;
export type UpdatePasswordActionType = (passwordChange: PasswordChangeInfo) => Promise<boolean>;
export type UpdateEmailActionType = (email: string) => Promise<boolean>;
export type PauseUserSubscriptionActionType = ({
    subscriptionId,
    resumeDate,
}: {
    subscriptionId: string;
    resumeDate: Date;
}) => Promise<boolean>;
export type ResumeUserSubscriptionActionType = (subscriptionId: string) => Promise<boolean>;
export type CancelUserSubscriptionActionType = (subscriptionId: string) => Promise<boolean>;
